<template>
  <v-snackbar
    v-model="snackbar.show"
    :timeout="snackbar.timeout"
    :color="snackbar.color"
    bottom
    elevation="2"
    text
  >
    {{ snackbar.message }}
    <template v-slot:action="{ attrs }">
      <v-btn
        color="black"
        text
        fab
        v-bind="attrs"
        @click="snackbar.show = false"
        class="os-rounded"
      >
        <Icon
          :width="24"
          :color="'rgba(0,0,0,.54)'"
          :icon="'close'"
        />
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>

/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  computed: {
    snackbar () {
      return this.$store.state.snackbar
    }
  },
  components: {
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  }
})

export default class Notification extends Vue {
  mounted () {
    setTimeout(() => {
      this.checkOnlineState()
    }, 1000)
  }

  notify (data) {
    this.snackbar.message = data.message
    this.snackbar.color = data.color
    this.snackbar.show = true
  }

  hide () {
    this.snackbar.show = false
  }

  connectionAlert () {
    const data = {
      message: 'Se perdió la conexión de red. Se está intentando restablecer.',
      color: 'error'
    }

    this.notify(data)
  }

  checkOnlineState () {
    window.addEventListener('online', () => {
      this.hide()
    })

    window.addEventListener('offline', () => {
      this.connectionAlert()
    })
  }
}
</script>
